<div class="outer-container">
  <div class="main-container">
    <mat-card class="pick-sheet-card">
      <mat-card-header class="pick-sheet-card-header">
        <div class="pick-sheet-title-row">
          <mat-card-title>Pick Sheet</mat-card-title>
          <mat-card-subtitle *ngIf="loadId != null">Load ID: {{ loadId }}</mat-card-subtitle>
        </div>
      </mat-card-header>
      <mat-card-content>
        <ov-suite-clean-table
          #pickTable
          [columnData]="columnData"
          [dataSource]="dataSource"
          emptyMessage="No Picks Currently"
        >
        </ov-suite-clean-table>
      </mat-card-content>
    </mat-card>
  </div>
</div>
